// extracted by mini-css-extract-plugin
module.exports = {"faqAccordionContent":"faq_accordion_faqAccordionContent__J3a4N"};